export function setValue(actionType, data) {
    return {
        type: actionType,
        payload: data,
    };
}